import { AppShell } from './AppShell';
import DashboardIcon from '@mui/icons-material/Dashboard';
import GroupsIcon from '@mui/icons-material/Groups';
import EventIcon from '@mui/icons-material/Event';
import MedicalServicesIcon from '@mui/icons-material/MedicalServices';
import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn';
import ReviewsIcon from '@mui/icons-material/Reviews';
import Inventory2Icon from '@mui/icons-material/Inventory2';
import SubscriptionsIcon from '@mui/icons-material/Subscriptions';
import AccountTreeIcon from '@mui/icons-material/AccountTree';
import HubIcon from '@mui/icons-material/Hub';
import BusinessIcon from '@mui/icons-material/Business';

export function PracticeLayout() {
  return (
    <AppShell noHeader
      brand={{
        title: 'MyBooking Practice',
        subtitle: 'Practice admin',
        href: '/practice',
      }}
      sections={[
        {
          items: [
            { to: '/practice',              label: 'Overview',     icon: <DashboardIcon />, exact: true },
            { to: '/practice/profile',      label: 'Profile',      icon: <BusinessIcon /> },
          ],
        },
        {
          heading: 'People & catalog',
          items: [
            { to: '/practice/clinicians',        label: 'Clinicians',     icon: <GroupsIcon /> },
            { to: '/practice/procedures',        label: 'Procedures',     icon: <MedicalServicesIcon /> },
            { to: '/practice/intake-templates',  label: 'Intake forms',   icon: <AssignmentTurnedInIcon /> },
          ],
        },
        {
          heading: 'Operations',
          items: [
            { to: '/practice/appointments', label: 'Appointments', icon: <EventIcon /> },
            { to: '/practice/reviews',      label: 'Reviews',      icon: <ReviewsIcon /> },
          ],
        },
        {
          heading: 'Commerce',
          items: [
            { to: '/practice/care-packages',     label: 'Care packages', icon: <Inventory2Icon /> },
            { to: '/practice/membership-plans',  label: 'Memberships',   icon: <SubscriptionsIcon /> },
            { to: '/practice/payer-contracts',   label: 'Payer contracts', icon: <AccountTreeIcon /> },
          ],
        },
        {
          heading: 'Integrations',
          items: [
            { to: '/practice/interop', label: 'Interop mesh', icon: <HubIcon /> },
          ],
        },
      ]}
    />
  );
}
